var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _c("div", { staticClass: "col-5" }, [
        _c("h5", [_vm._v(_vm._s(_vm.pageTitle))]),
      ]),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info btn_right",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v(" 一覧へ戻る ")]
        ),
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-danger btn_right",
            attrs: { id: "destroyBtn", type: "button" },
            on: { click: _vm.destroy },
          },
          [_vm._v(" 削除する ")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "div",
            {
              staticClass: "row",
              staticStyle: { height: "90px", padding: "10px 0" },
            },
            [
              _vm._m(0),
              _c("div", { staticClass: "col-8" }, [
                _vm._v(" " + _vm._s(_vm.$route.params.key) + " "),
              ]),
            ]
          ),
          _c("div", { staticClass: "row", staticStyle: { height: "130px" } }, [
            _vm._m(1),
            _c("div", { staticClass: "col-3" }, [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isBlobUrl,
                    expression: "!isBlobUrl",
                  },
                ],
                staticClass: "card-img",
                attrs: { src: "/card-image.svg" },
              }),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isBlobUrl,
                    expression: "isBlobUrl",
                  },
                ],
                staticClass: "trim-circle",
                style: { backgroundImage: "url(" + _vm.blobUrl + ")" },
              }),
            ]),
            _c("div", { staticClass: "col-1" }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-2" }, [
      _c("label", [_vm._v("タイトル")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-2" }, [
      _c("label", [_vm._v("イメージ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }